// import React, { useEffect, useState } from 'react';


// const DisclaimerPopup = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     const hasVisited = document.cookie.includes('disclaimerAccepted=true');
//     if (!hasVisited) {
//       setShowPopup(true);
//     }
//   }, []);

//   const handleClose = () => {
//     document.cookie = "disclaimerAccepted=true; path=/; max-age=31536000"; // 1 year
//     setShowPopup(false);
//   };

//   if (!showPopup) return null;

//   return (
//     <div className="disclaimer-overlay">
//       <div className="disclaimer-popup">
//         <h2>Disclaimer</h2>
//         <p>
//           This website uses cookies to enhance user experience. By using this website, you agree to our terms and conditions.
//         </p>
//         <button onClick={handleClose}>I Understand</button>
//       </div>
//     </div>
//   );
// };

// export default DisclaimerPopup;







import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSocialMediaSettings } from "../../reducers/commonReducer";

const DisclaimerPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );

  useEffect(() => {
    const hasVisited = document.cookie.includes('disclaimerAccepted=true');
    if (!hasVisited) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    dispatch(getSocialMediaSettings());
  }, [dispatch]);

  const handleClose = () => {
    document.cookie = "disclaimerAccepted=true; path=/; max-age=31536000"; // 1 year
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-popup">
        <div
          dangerouslySetInnerHTML={{
            __html: getSocialMediaSettingsData?.disclaimer|| '',
          }}
        />
        <button onClick={handleClose}>I Understand</button>
      </div>
    </div>
  );
};

export default DisclaimerPopup;

